<template>
  <div class="collapse-wrap">
    <div v-if="isGroup">
      <div
        @click="toggleCollapse"
        class="collapse-wrap__header"
        :class="{ open: isOpen }"
      >
        <div
          v-if="showGroupCheckbox"
          class="group-checkbox"
          :class="getGroupStateStyle"
        >
          <or-icon icon="done" />
          <span class="minus">-</span>
          <input
            type="checkbox"
            :checked="isGroupChecked"
            @change.stop="toggleGroupCheckbox"
            @click.stop
          />
        </div>
        <or-icon
          class="arrow"
          :class="{ open: isOpen }"
          icon="arrow_drop_down"
        />
        <span class="label">
          {{ $t('model.nlu-model.sidebar.versions.versions_group.unnamed') }}
        </span>
        <span class="amount">({{ versionsAmount }})</span>
      </div>
      <div v-if="isOpen">
        <div v-for="(ver, index) in item" :key="index" class="item-wrap">
          <VersionItem
            :item="ver"
            :edit-mode="editMode"
            :checked-set="checkedSet"
            :delete-ver-proc="deleteVerProc"
          />
        </div>
      </div>
    </div>
    <VersionItem
      v-else
      :item="item"
      :edit-mode="editMode"
      :checked-set="checkedSet"
      :delete-ver-proc="deleteVerProc"
    />
  </div>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import VersionItem from './version_item'

export default {
  components: { VersionItem },

  props: {
    groups: Array,
    index: Number,
    editMode: Boolean,
    checkedSet: Array,
    deleteVerProc: Object
  },

  computed: {
    item () {
      return this.groups[this.index]
    },

    isGroup () {
      return _.isArray(this.item)
    },

    versionsAmount () {
      return this.item.length
    },

    showGroupCheckbox () {
      return this.editMode
    },

    getGroupStateStyle () {
      const idSet = _.chain(this.groups[this.index])
        .map(item => (!item.isPublish && !item.isCurrent ? item.id : null))
        .compact()
        .value()

      const ms = _.some(idSet, id => _.includes(this.checkedSet, id))

      if (this.isGroupChecked) {
        return 'checked'
      }
      if (ms) {
        return 'middlestate'
      }
      return ''
    },

    isGroupChecked () {
      const idSet = _.chain(this.groups[this.index])
        .map(item => (!item.isPublish && !item.isCurrent ? item.id : null))
        .compact()
        .value()

      return _.every(idSet, id => _.includes(this.checkedSet, id))
    }
  },

  data () {
    return {
      isOpen: false
    }
  },

  methods: {
    toggleCollapse () {
      this.isOpen = !this.isOpen
    },

    toggleGroupCheckbox () {
      KnowledgeBus.$emit('checkbox-group::toggle', this.groups[this.index])
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-wrap {
  .item-wrap {
    .item > .wrap {
      margin-left: 20px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: left;
    height: 32px;
    width: 100%;
    padding: 0 16px 0;
    color: $or-black-blue;

    &:hover {
      background-color: $or-grey-light;
      cursor: pointer;
    }

    &.open {
      background-color: $or-grey-light;
      transition: all 0.2s ease;

      &:hover {
        background-color: darken($or-grey-light, 5%);
      }
    }

    .group-checkbox {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      border: 1px solid $or-grey-medium;
      border-radius: 2px;
      margin-right: 4px;

      &.checked {
        background-color: $or-blue;
        border: none;

        &:hover {
          background-color: darken($or-blue, 5%);
          transition: all 0.2s ease;
        }

        .material-icons {
          display: block;
        }
      }

      &.middlestate {
        background-color: $or-blue;
        border: none;
        color: white;

        &:hover {
          background-color: darken($or-blue, 5%);
          transition: all 0.2s ease;
        }

        .minus {
          display: block;
          margin-bottom: 2px;
        }
      }

      input {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: 0;

        &:hover {
          cursor: pointer;
        }
      }

      .material-icons {
        display: none;
        color: #fff;
        font-size: 12px;
      }

      .minus {
        color: white;
        display: none;
      }
    }

    .arrow {
      font-size: 18px;
      transition: all 0.2s ease;
      margin-right: 4px;

      &:not(.open) {
        transform: rotate(-90deg);
      }
    }

    .label {
      font-size: 14px;
      margin-right: 4px;
    }

    .amount {
      font-weight: bold;
    }
  }
}
</style>

<style lang="scss">
.collapse-wrap {
  .item-wrap {
    .item > .wrap {
      margin-left: 20px;
    }
  }
}
</style>
